import React from "react";
import { Button } from "flowbite-react";
import ChangePasswordModal from "../../../modals/ChangePasswordModal";
import DeleteAccountModal from "../../../modals/DeleteAccountModal";

const SettingsTab = ({ 
  isPasswordModalOpen, 
  setIsPasswordModalOpen, 
  isDeleteAccountModalOpen, 
  setIsDeleteAccountModalOpen,
  handlePasswordChange,
  handleAccountDeletion
}) => {
  return (
    <div className="animate-fadeIn">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-6">Account Settings</h2>
      
      <div className="space-y-6">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="p-5 border-b border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-medium text-gray-800 dark:text-white">Email Notifications</h3>
          </div>
          <div className="p-5 space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium text-gray-800 dark:text-white">Account updates</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Get notified when there are changes to your account</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" value="" className="sr-only peer" defaultChecked />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium text-gray-800 dark:text-white">Token usage alerts</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Receive alerts when your token usage is high</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" value="" className="sr-only peer" defaultChecked />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium text-gray-800 dark:text-white">Marketing emails</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Receive information about new features and offers</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" value="" className="sr-only peer" />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
          </div>
        </div>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="p-5 border-b border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-medium text-gray-800 dark:text-white">Security Settings</h3>
          </div>
          <div className="p-5 space-y-6">
            <div>
              <h4 className="font-medium text-gray-800 dark:text-white mb-2">Password Management</h4>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">It's a good idea to change your password periodically for security</p>
              <Button 
                color="blue"
                onClick={() => setIsPasswordModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                Change Password
              </Button>
            </div>
            <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
              <h4 className="font-medium text-gray-800 dark:text-white mb-2">Account Deletion</h4>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">Permanently delete your account and all your data</p>
              <Button 
                color="failure" 
                onClick={() => setIsDeleteAccountModalOpen(true)}
                className="bg-red-600 hover:bg-red-700 text-white"
              >
                Delete Account
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Import the modals from their separate files */}
      <ChangePasswordModal 
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
        onPasswordChange={handlePasswordChange}
      />
      
      <DeleteAccountModal
        isOpen={isDeleteAccountModalOpen}
        onClose={() => setIsDeleteAccountModalOpen(false)}
        onDeleteAccount={handleAccountDeletion}
      />
    </div>
  );
};

export default SettingsTab; 